mod.modules.define("ScreenerPageExpanded", "BaseScreenerPage", function(fn) {

	fn.prototype.init = function(params) {
	    this.base("init", params);

		this.$screenerContainer = this.el;
		this.$screenerContent = this.el;
		this.$criteriaTab = $("#tab-criteria");


		this.pageSize = params.inputs.RowCount;

		this.$criteriaTab.attr("data-fields", JSON.stringify(params.criteriaColumns));

		this.initScreener(params.inputs);
	};

	fn.prototype.initScreener = function (initialArgs) {

		this.base("initScreener");

		// Set up the initial arguments
	    try {
	        if (initialArgs.SortArguments) {
	            delete initialArgs.SortArguments;
	        }
		    this.ScreenerInputs.Parse(initialArgs);
		}
	    catch (e) {
	        console.warn('ScreenerPageExpanded.js: ', e);
	    }
	};

	// --------------------------------------------------------------------------
	// Screens
	// --------------------------------------------------------------------------

	fn.prototype.runScreen = function(resultFields) {
		this.buildScreenInputs(resultFields);
		this.ScreenerUtilityInstance.DoScreen(true);
	};

	fn.prototype.screenRequestCallback = function(response) {
		this.base("screenRequestCallback", response);
	};

	fn.prototype.buildScreenInputs = function (resultFields) {
		this.ScreenerInputs.SetResultFields(resultFields);
		this.addExcludedIssueIdArgs(this.excludedIssueIds);
	};

	fn.prototype.events = {
	    "[data-action=download-screen]": {
	        "click": function (e, $el) {
	            var $modal = $el.closest('div.modal-body');
	            var $selectedInput = $modal.find('div.config-section input:checked');
	            var selectedType = $selectedInput.val();

	            // Kick off the download
	            this.downloadResults(selectedType, function () {
	                $("#screener_download").modal("hide");
	            });
	        }
	    },
	    "div.modal [data-action=cancel]": {
	        "click": function (e, $el) {
	            $el.closest("div.modal").modal("hide");
	        }
	    }
	};

});